export interface IAutoDisconnectMutationObserverConf {
  /** Por defecto es true */
  runCallbackOnInit?: boolean;
  /** Por defecto es 100 (ms) */
  timeout?: number;
}

/**
 * Crea un observer que va a desconectarse automáticamente luego de que pase
 * una determinada cantidad de tiempo sin actividad en el elemento.
 *
 * Se usa especialmente para esperar que un componente termine de renderizar y
 * aplicar cálculos a nivel de layout sobre él.
 */
export function autoDisconnectMutationObserver(
  element: HTMLElement,
  callback: () => unknown,
  conf?: IAutoDisconnectMutationObserverConf,
) {
  let timeoutRegister = -1;
  let isConnected = false;
  function disconnect() {
    if (isConnected) {
      isConnected = false;
      observer.disconnect();
      clearTimeout(timeoutRegister);
    }
  }
  let shoutCallback: number;

  const observer = new MutationObserver((...props) => {
    if (props[0]?.[0] && (props[0][0].removedNodes || props[0][0].addedNodes)) {
      clearTimeout(shoutCallback);
      shoutCallback = setTimeout(callback, 100) as unknown as number;
      clearTimeout(timeoutRegister);
      timeoutRegister = setTimeout(
        disconnect,
        conf?.timeout ?? 100,
      ) as unknown as number;
    }
  });
  isConnected = true;
  observer.observe(element, { subtree: true, childList: true });
  timeoutRegister = setTimeout(
    disconnect,
    conf?.timeout ?? 100,
  ) as unknown as number;

  if (conf?.runCallbackOnInit !== false)
    shoutCallback = setTimeout(callback, 100) as unknown as number;

  return disconnect;
}
